module.exports = __webpack_public_path__ + "static/media/meditation10.4d4ac987.mp3";